import React from "react";
import { Header } from "../components/Header";
import { AboutCarousel } from "../components/AboutCarousel";
import { Manifesto } from "../components/Manifesto";
import { Founders } from "../components/Founders";
import { ContactFooter } from "../components/ContactFooter";
import { useLanguage } from "../i18n";

export default function AboutPage() {
  const { t } = useLanguage();
  return (
    <div data-testid="about-page" className="min-h-screen bg-cream">
      <Header />
      <main>
        <AboutCarousel label={t.nav.about} />
        <Manifesto />
        <Founders />
      </main>
      <ContactFooter />
    </div>
  );
}
